import { gql } from "@apollo/client";

export const EDIT_USER = gql`
    mutation updateUser($userId: ID!, $input: UserUpdateInput! ){
        updateUser(userId: $userId, input: $input){
            _id
            firstName
            lastName
            role
            email
        }
    }
`